import { render, staticRenderFns } from "./AttrCommonTab.vue?vue&type=template&id=804b64dc&"
import script from "./AttrCommonTab.vue?vue&type=script&lang=js&"
export * from "./AttrCommonTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports